export function IconBell() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7501 6.75C15.7501 5.1587 15.1179 3.63258 13.9927 2.50736C12.8675 1.38214 11.3414 0.75 9.75006 0.75C8.15876 0.75 6.63264 1.38214 5.50742 2.50736C4.3822 3.63258 3.75006 5.1587 3.75006 6.75C3.75006 13.75 0.750061 15.75 0.750061 15.75H18.7501C18.7501 15.75 15.7501 13.75 15.7501 6.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(2.25 1.25)"
        vectorEffect="non-scaling-size"
      />
      <path
        d="M4.21012 0.750124C4.03431 1.0532 3.78197 1.30478 3.47835 1.47965C3.17473 1.65453 2.8305 1.74658 2.48012 1.74658C2.12974 1.74658 1.78551 1.65453 1.4819 1.47965C1.17828 1.30478 0.925934 1.0532 0.750124 0.750124"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(9.52 20.25)"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
